<template>
  <div class="main">
    <c-panel title="Abastecimentos" titleIcon="fas fa-gas-pump">
      <list></list>
    </c-panel>
  </div>
</template>

<script>
import list from "./list"

export default {
  components: { list }
}
</script>

